<template>
    <template v-if="inclFB">FaenaDonut.vue: template beg<br></template>
    <div class="p-0 ">
        <template v-if="inclFB">FaenaDonut.vue: series.length={{ series.length }}, series={{ series }}.<br></template>
        <template v-if="inclFB">FaenaDonut.vue: idFaena={{ idFaena }}, mensual={{ mensual }}, modOpe={{ modOpe }}.<br></template>
        <!--
        <apexchart v-if="series.length > 0 "
        type="donut"
        ref="realtimePie"
        :options="chartOptions" :series="series"></apexchart>
        <div v-if="!series.length "  class="flex justify-center items-center w-full h-full text-center">
            <span class="text-2xl text-gray-500"> {{ $t('sindatosdegeneracion') }}  </span>
        </div>
        -->
        <div v-if="modOpe.length===0" class="flex justify-center items-center w-full h-full text-center">
            <span class="text-2xl text-gray-500">cargando ...</span>
        </div>
        <apexchart v-else type="donut" ref="realtimePie" :options="chartOptions" :series="modOpe">
        </apexchart>
    </div>
    <template v-if="inclFB">FaenaDonut.vue: template end<br></template>
</template>
<script>
import VueApexCharts from "vue3-apexcharts";
export default {
    props: [
       "idFaena", "mensual", "modOpe"
    ],
    beforeMount() {
        // Ejemplos si en apexchart se usa :series="series" en lugar de :series="modOpe": y en el div previo
        // series.length en lugar de modOpe.length.
        // this.series=[21,0,0,0, 79];    // Así aparece torta con colores 21% STANDARD, 79% STANDBY
        // this.series[0,0,0,0,0];        // Así no aparece ni torta ni texto
        // this.series=[];                // Así aparece texto "Sin datos de generación"
        // this.series=[22,0,0,8,70];     // Así aparece torta con colores 22% STANDARD, 8% AIRE, 70% STANDBY
    },
    components: {
        apexchart: VueApexCharts,
    },
    data: function () {
        return {
            series: Array,
            chartOptions: {
                chart: {
                    type: 'donut',
                },
                //colors: ['#4596f9', '#40ce71', '#FB923C', '#FACC14', '#F87171'],
                //labels: ['Standard', 'Eco', 'Max Load',  'Aire', 'Stand-by'],
                colors: ['#4596f9',  '#40ce71',  '#FB923C', '#FACC14', '#EF4444'],
                labels: ['STANDARD', 'ECO',     'MAXLOAD',   'AIRE', 'STANDBY'],
                dataLabels: {
                    enabled: false,
                    style: {
                        colors: ['#4596f9',   '#FB923C', '#FACC14', '#EF4444']
                       //  colors: ['blue', 'green', 'orange', 'yellow', '#000000'],
                    }
                },
                legend: {
                    show: false
                },
                plotOptions: {
                    pie: {
                        offsetX: 0,
                        offsetY: 0,
                        customScale: 1,
                        donut: {
                            background: 'transparent',
                            size: "1%"
                        }
                    }
                }
            },
            inclFB: false
        }
    }
}
</script>
